import {routerReducer, RouterReducerState} from '@ngrx/router-store';
import {InjectionToken} from '@angular/core';
import {Action, ActionReducerMap} from '@ngrx/store';
import {ERROR_FEATURE_KEY, errorReducer, ErrorState} from 'app/core/components/error-page/state/error.reducer';

export interface AppState {
  router: RouterReducerState;
  [ERROR_FEATURE_KEY]: ErrorState;
}

export const APP_REDUCERS: InjectionToken<ActionReducerMap<AppState, Action>> = new InjectionToken<
  ActionReducerMap<AppState, Action>
>('Root reducers token', {
  factory: () => ({
    router: routerReducer,
    [ERROR_FEATURE_KEY]: errorReducer,
  }),
});
